window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }
      var $gallery = $('.main-gallery');
      if ($gallery.hasClass('slick-initialized')) {
        var position = $gallery
          .find(".slick-slide:not('.slick-cloned') [data-image-id='" + variant.featured_image.id + "']")
          .closest('.slick-slide')
          .data('slick-index');

        $gallery.slick('slickGoTo', position );
      }


      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    backStockContainer: '[data-back-container]',
    rewardsPoints: '[data-reward-points]',
    productCountdown: '[data-countdown]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    freeShipping: '[data-free_shipping]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productQuantity: '[data-product-qty]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true).removeClass('hide');
        $(selectors.productCountdown, this.$container).removeClass('hide');
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false).removeClass('hide');
        $(selectors.productCountdown, this.$container).removeClass('hide');
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        $(selectors.backStockContainer, this.$container).addClass('hide');

      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true).addClass('hide');
        $(selectors.productCountdown, this.$container).addClass('hide');
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(selectors.backStockContainer, this.$container).removeClass('hide');
      }

      if (variant.inventory_management === 'shopify') {
        var inventory_policy = $(selectors.originalSelectorId).find('option[value='+variant.id+']').data('inventory_policy');

        if (inventory_policy === "continue") {
          $(selectors.productQuantity, this.$container)
            .attr('max', 10);
          $(selectors.productQuantity).val(1);
        } else {
          $(selectors.productQuantity, this.$container)
            .attr('max', $(selectors.originalSelectorId)
              .find('option[value='+variant.id+']').data('quantity'));
          $(selectors.productQuantity).val(1);
        }
      }

    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      var freeShipping = $(selectors.freeShipping, this.$container).data('free_shipping');

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      $(selectors.rewardsPoints, this.$container)
        .html(Math.floor((variant.price / 100)) * window.theme.grayPoints);

      if ( $('.product-note').length === 1) {
        if (variant.price > 24999) {
          $('.product-note').removeClass('hide');
        } else {
          $('.product-note').addClass('hide');
          $('.product-note input').val('');
        }
      }

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }

      if (freeShipping > variant.price) {
        $(selectors.freeShipping, this.$container).addClass('hide')
      } else {
        $(selectors.freeShipping, this.$container).removeClass('hide')
      }

    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * Toggles <video> src conditionally based on data attributes to
 * prevent wasted bandwidth when hidden.
 *
 * @requires vendor/lodash.throttle.js
 */

(function modVideoRespSrc() {
  var THROTTLE_WAIT_MS = 250;

  var selectors = {
    mediumUp: '[data-medium-up--src]'
  };

  var mediumUp = 'only screen and (min-width: 150px)';

  function checkSrcs() {
    var $mediumUp;

    if (window.matchMedia(mediumUp).matches) {
      $mediumUp = $(selectors.mediumUp);

      $mediumUp.each(function eachMediumUp() {
        var src = $(this).attr('data-medium-up--src');
        var $video = $(this).closest('video');

        if (!$video.length || !src) {
          return;
        }

        $(this)
          .attr('src', src)
          .removeAttr('data-medium-up--src');

        $video[0].load();
        // eslint-disable-next-line no-console
        console.log('[video-responsive-src] loaded video src');
      });
    }
  }

  function init() {
    checkSrcs();
    $(window).on('resize', window.throttle(checkSrcs, THROTTLE_WAIT_MS));
  }

  init();
})();

/*

  Javascript based GeoIP service using the MaxMind JS API

  Usage:

  CREATE NEW INSTANCE
  -------------------

  var geoip = new GeoIPService();


  AVAILABLE METHODS
  -----------------

  1. Perform IP Lookup and show Popup:

  geoip.getLocation();

  2. Return Country Info only:

  geoip.countryLookup(function() {
    console.log(geoip.getCountryName());    // Returns the country name
    console.log(geoip.getCountryStore());   // Returns the store associated with their country e.g. UK, US, ROW etc
  });

*/

(function() {

  // early return if geoip settings aren't available

  if (!window.rfd || !window.rfd.geoip) {
    console.log('[GEOIP] no settings available');
    return;
  }

  var cookiesEnabled = window.rfd.geoip.enable_cookies;
  var redirectEnabled = window.rfd.geoip.enable_geoip;
  var overlayEnabled = window.rfd.geoip.display_country_select;
  var currentStore = window.rfd.geoip.geoip_current_store;
  var rowStore = window.rfd.geoip.geoip_row_store;
  var countryStore = window.rfd.geoip.geoip_current_country;
  var countryName = '';
  var cookieName = 'geoipRedirect';
  var cookieDomain = '.gilbertrugby.com';
  var isLocalhost = window.location.hostname === 'localhost' ||
    window.location.hostname.indexOf('192.168.') !== -1;

  if (window.location.hostname.indexOf("myshopify.com") != -1) {
    cookieDomain = '.myshopify.com';
  }

  console.log(cookieDomain);

  GeoIPService = (function() {

    /* Store Configuration */
    var stores = {
      'uk' : window.rfd.geoip.uk,
      'fr' : window.rfd.geoip.fr
    };

    /* Country to Store Configuration */
    var countries = {
      'US' : { 'Name':'USA', 'Store': 'uk' },
      'GB' : { 'Name':'United Kingdom', 'Store':'uk' },
      'FI' : { 'Name':'Finland', 'Store':'uk' },
      'DK' : { 'Name':'Denmark', 'Store':'uk' },
      'SE' : { 'Name':'Sweden', 'Store':'uk' },
      'NO' : { 'Name':'Norway', 'Store':'uk' },
      'AL' : { 'Name':'Albania', 'Store':'uk' },
      'AD' : { 'Name':'Andorra', 'Store':'uk' },
      'AT' : { 'Name':'Austria', 'Store':'uk' },
      'BY' : { 'Name':'Belarus', 'Store':'uk' },
      'BE' : { 'Name':'Belgium', 'Store':'uk' },
      'BA' : { 'Name':'Bosnia and Herzegovina', 'Store':'uk' },
      'BG' : { 'Name':'Bulgaria', 'Store':'uk' },
      'HR' : { 'Name':'Croatia', 'Store':'uk' },
      'CY' : { 'Name':'Cyprus', 'Store':'uk' },
      'CZ' : { 'Name':'Czech Republic', 'Store':'uk' },
      'EE' : { 'Name':'Estonia', 'Store':'uk' },
      'FO' : { 'Name':'Faroe Islands', 'Store':'uk' },
      'FR' : { 'Name':'France', 'Store':'fr' },
      'DE' : { 'Name':'Germany', 'Store':'uk' },
      'GI' : { 'Name':'Gibraltar', 'Store':'uk' },
      'GR' : { 'Name':'Greece', 'Store':'uk' },
      'HU' : { 'Name':'Hungary', 'Store':'uk' },
      'IS' : { 'Name':'Iceland', 'Store':'uk' },
      'IE' : { 'Name':'Ireland', 'Store':'uk' },
      'IT' : { 'Name':'Italy', 'Store':'uk' },
      'LV' : { 'Name':'Latvia', 'Store':'uk' },
      'LI' : { 'Name':'Liechtenstein', 'Store':'uk' },
      'LT' : { 'Name':'Lithuania', 'Store':'uk' },
      'LU' : { 'Name':'Luxembourg', 'Store':'uk' },
      'MK' : { 'Name':'Macedonia', 'Store':'uk' },
      'MT' : { 'Name':'Malta', 'Store':'uk' },
      'MD' : { 'Name':'Moldova', 'Store':'uk' },
      'MC' : { 'Name':'Monaco', 'Store':'uk' },
      'NL' : { 'Name':'Netherlands', 'Store':'uk' },
      'PL' : { 'Name':'Poland', 'Store':'uk' },
      'PT' : { 'Name':'Portugal', 'Store':'uk' },
      'RO' : { 'Name':'Romania', 'Store':'uk' },
      'RU' : { 'Name':'Russia', 'Store':'uk' },
      'SM' : { 'Name':'San Marino', 'Store':'uk' },
      'RS' : { 'Name':'Serbia', 'Store':'uk' },
      'SK' : { 'Name':'Slovakia', 'Store':'uk' },
      'SI' : { 'Name':'Slovenia', 'Store':'uk' },
      'ES' : { 'Name':'Spain', 'Store':'uk' },
      'CH' : { 'Name':'Switzerland', 'Store':'uk' },
      'UA' : { 'Name':'Ukraine', 'Store':'uk' },
      'VA' : { 'Name':'Vatican city', 'Store':'uk' },
      'IM' : { 'Name':'Isle of Man', 'Store':'uk' },
      'ME' : { 'Name':'Montenegro', 'Store':'uk' },
      'CA' : { 'Name':'Canada', 'Store':'ca' },
      'GG' : { 'Name':'Guernsey', 'Store':'uk' },
      'JE' : { 'Name':'Jersey', 'Store':'uk' },
      'AU' : { 'Name':'Australia', 'Store':'uk' }
    };

    /* GeoIPService Constructor */
    function GeoIPService() { }

    /* GeoIPService Functions */
    GeoIPService.prototype = $.extend({}, GeoIPService.prototype, {

      // Perform GeoIP Lookup
      getLocation: function() {
        console.log('[GEOIP] performing lookup');
        if (this.getQueryStringParameter('gclid') || this.getQueryStringParameter('gclid') === undefined) {
          var cookied = this.getRedirectCookie();
          if (cookied) {
            if (isLocalhost) {
              console.log('[GEOIP] on localhost, skipping redirect');
              return;
            }

            if (cookied !== 'correct') {
              console.log('[GEOIP] getLocation redirecting to', cookied);
              window.top.location.href = cookied;
            } else {
              console.log('[GEOIP] no action required');
              return;
            }
          } else {
            geoip2.country(this.processResponse, this.processError);
          }
        }
      },

      // Process GeoIP Lookup Results and show appropriate popup
      processResponse: function(data) {

        var location = 'ROW';

        if (typeof(data.country.iso_code) !== 'undefined') {
          if (typeof(countries[data.country.iso_code]) !== 'undefined') {
            if (countries[data.country.iso_code]['Store'] !== currentStore) {
              location = countries[data.country.iso_code]['Store'];
            } else {
              console.log('[GEOIP] on the correct store', data.country.iso_code);
              return;
            }
          }
        }

        if (location === 'ROW') {
          location = rowStore;
        }

        // used for ROW results
        if (currentStore === location) {
          console.log('[GEOIP] on the correct store already', currentStore);
          return;
        }

        console.log('[GEOIP] suggesting location', location);
        showPopUpTwo(location);

      },

      // Process GeoIP Lookup Error
      processError: function(data) {
        console.log("[GEOIP] fail - " + JSON.stringify(data, undefined, 4));
      },

      /* COUNTRY ONLY FUNCTION */

      // Perform IP lookup and return data
      countryLookup: function(callback) {
        var that = this; // I know…
        geoip2.country(
          function(data) {
            that.setCountry(data);
            if (callback) {
              callback();
            }
          },
          function(data) {
            that.processError(data);
            if (callback) {
              callback();
            }
          }
        );
      },

      // Store the Country Name and correct country store
      setCountry: function(data) {
        countryName = data.country.names.en;

        if (typeof(countries[data.country.iso_code]) !== 'undefined') {
          countryStore = countries[data.country.iso_code]['Store'];
        }
      },

      // Return the stores country name
      getCountryName: function(data) {
        return countryName;
      },

      // Return the stores country name
      getCountryStore: function(data) {
        return countryStore;
      },

      // Return the stores URL
      getCountryUrl: function(data) {
        return stores[countryStore];
      },

      /* HELPER FUNCTIONS */

      // Check for specified query string parameter
      getQueryStringParameter: function(parameter) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i=0; i < sURLVariables.length; i++) {
          var sParameterName = sURLVariables[i].split('=');
          if (sParameterName[0] == parameter) {
            return sParameterName[1];
          }
        }
      },

      // Check if the redirect cookie already exists
      getRedirectCookie: function() {
        console.log('[GEOIP] cookie val', Cookies.get(cookieName));
        if (Cookies.get(cookieName)) {
          var thisLocation =  window.location.host;
          var cookiedLocation = Cookies.get(cookieName);
          var cookieNoProtocol = cookiedLocation.replace("https://","").replace("http://", "").replace("\/", "");

          if (cookieNoProtocol == thisLocation) {
            return "correct";
          } else {
            return "https://" + cookieNoProtocol + window.location.pathname + window.location.search;
          }
        }
        return false;
      }

    });

    return GeoIPService;

  })();

  function getRedirectUrl(base) {
    return base + window.location.pathname + window.location.search;
  }

  // Show the popup to a client that is on the wrong store.
  // function showPopUpOne(suggested_region) {
  //   $('.country-select-ui').show();
  // }

  // Show the popup to a client that has no suggested store..
  function showPopUpTwo(go_to_store) {
    Cookies.set('geoipSelector', true, { expires: 90, path: '/', domain: cookieDomain });
    $(".country-select-ui-geoip .country-select-column li").hide();
    $(".stay-store li a[data-region-code='" + currentStore.toUpperCase() + "']").parent().show();
    $(".go-to-store li a[data-region-code='" + go_to_store.toUpperCase() + "']").parent().show();
    $('.country-select-ui-geoip').show();
  }

  function geoip_getRedirectUrl(base) {
    return base + window.location.pathname + window.location.search;
  }

  function geoip_redirect(url) {
    console.log('[GEOIP] geoip_redirect redirecting to', url);

    if (url.indexOf('//' + window.location.host) === -1) {
      if (cookiesEnabled) {
        Cookies.set('', url, { expires: 90, path: '/', domain: cookieDomain });
      }

      var baseDomain = url;
      var fullDomain = geoip_getRedirectUrl(baseDomain);

      if (isLocalhost) {
        console.log('[GEOIP] on localhost, skipping redirect');
        return;
      }

      window.top.location.href = fullDomain;
    } else {
      console.log('[GEOIP] already on domain, skipping redirect');
    }
  }

  function handleOptionClick(e) {
    e.preventDefault();

    var baseDomain = $(this).attr("href");
    var fullDomain = getRedirectUrl(baseDomain);

    var isStay = $(this).parents('.stay-store').length;

    if (isStay) {
      Cookies.set('geoipRedirect', window.location.host, { expires: 90, path: '/', domain: cookieDomain });
      $('.country-select-ui-geoip').fadeOut(500);
      return;
    }

    if (cookiesEnabled) {
      Cookies.set('geoipRedirect', $(this).attr("href"), { expires: 90, path: '/', domain: cookieDomain });
    }

    if (window.location.href.search( baseDomain ) === -1) {
      window.top.location.href = fullDomain;
    } else {
      $('.country-select-ui-geoip').fadeOut(500);
    }
  }

  function setThisCountry() {
    Cookies.set('geoipSelector', true, { expires: 90, path: '/', domain: cookieDomain });
    Cookies.set('geoipRedirect', window.location.host, { expires: 90, path: '/', domain: cookieDomain });
  }
  function inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  function init() {
    if (inIframe()) {
      console.log('[GEOIP] in iframe, disabling');
      return;
    }

    if (!redirectEnabled) {
      console.log('[GEOIP] disabled');
      return;
    }

    if (!window.geoip2) {
      console.log('[GEOIP] not available (skipping country selector)');
      return;
    }

    // query string '?country-selected=true' means user selected this store
    // explicitly from country menu (on another store) so don't show overlay,
    // just set cookie to this domain as user has already chosen it
    var isCountrySelected = (window.location.search.search('country-selected=true') !== -1);
    if (isCountrySelected) {
      console.log('[GEOIP] pre-chosen, setting store as selection');
      return setThisCountry();
    }

    var geoip = new GeoIPService();

    if (overlayEnabled) {

      $('.country-select-ui-geoip .country-select-column a').click(handleOptionClick);
      geoip.getLocation();

    } else if (redirectEnabled) {

      geoip.countryLookup(function() {
        console.log('[GEOIP] user in', geoip.getCountryName(), 'Correct store', geoip.getCountryStore());
        geoip_redirect(geoip.getCountryUrl());
      });

    }
  }

  $(document).ready(function() {
    init();
  });

}());


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  $('a[href^="http"]').attr('target','_blank');

  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // cookie myclub

  var myClubCookie

  if ($('body').hasClass('template-collection-club')) {
    var collectionUrl = $('[data-collection]').data('collection');
    $.cookie('myClubGilbert', collectionUrl, {expires : 30, path: '/'});
    myClubCookie = collectionUrl;
  } else {
    myClubCookie = $.cookie('myClubGilbert');
  }
  if(myClubCookie) {
    $('div.site-nav--inner nav').prepend('<ul class="site-nav list--inline extra-club"><li class="menu-item my-club"><a href="'+myClubCookie+'" class="site-nav__link main">My Club</a></li></ul>');
    $('div.mm-panels .site-nav').prepend('<li class="menu-item site-nav__link my-club mm-listitem"><a href="'+myClubCookie+'" class="mm-listitem__text">My Club</a></li>')
  }
});
